import getInstance from "../config/api";

export default class Complaint {
  static async fetchComplaintsByUserId(userId) {
    const instance = getInstance();
    const { data } = await instance.get("/complaints/user", {
      params: { userId },
    });
    return data;
  }

  static async fetchComplaintById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/complaints/${id}`);
    return data;
  }

  static async createComplaint(body) {
    const instance = getInstance();
    const { data } = await instance.post("/complaints", body);
    return data;
  }

  static async updateComplaint(id, body) {
    const instance = getInstance();
    const { data } = await instance.put(`/complaints/${id}`, body);
    return data;
  }

  static async deleteComplaint(id) {
    const instance = getInstance();
    const { data } = await instance.delete(`/complaints/${id}`);
    return data;
  }
}
